export const FALLBACK_FEATURED = {
  customer_name: 'Priyesh Shah',
  route: 'Rajkot → Mumbai',
  travel_month: 'May 2025',
  review_text:
    'Atithi driver arrived 15 minutes early, helped with our luggage, and the final fare matched exactly what was quoted on WhatsApp. Highly recommended!',
  rating: 5,
  source: 'WhatsApp',
};

export const SOURCE_STYLES = {
  WhatsApp: 'bg-[#E8F5E9] text-[#2E7D32]',
  Google: 'bg-[#E3F2FD] text-[#1565C0]',
  Direct: 'bg-[#F0F0F0] text-[#666]',
  'Phone Call': 'bg-[#FFF3E0] text-[#E65100]',
  Other: 'bg-[#F0F0F0] text-[#666]',
};

export const formatTravelMonth = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleString('en-IN', { month: 'short', year: 'numeric' });
};

export const truncateReview = (text, max = 60) => {
  if (!text || text.length <= max) return text;
  return `${text.slice(0, max)}...`;
};

export const EMPTY_TESTIMONIAL_FORM = {
  customer_name: '',
  route: '',
  travel_month: '',
  review_text: '',
  rating: 5,
  source: 'WhatsApp',
  photo_url: '',
  is_featured: false,
  is_active: true,
  display_order: 0,
};

export const testimonialToForm = (t) => ({
  customer_name: t.customer_name || '',
  route: t.route || '',
  travel_month: t.travel_month || '',
  review_text: t.review_text || '',
  rating: t.rating ?? 5,
  source: t.source || 'WhatsApp',
  photo_url: t.photo_url || '',
  is_featured: Boolean(t.is_featured),
  is_active: t.is_active !== false,
  display_order: t.display_order ?? 0,
});
